// Build-time company identity for printed documents.
//
// CRA inlines process.env.REACT_APP_* at build time. A site built without the
// tenant env file (the Netlify dev preview, a fresh checkout) used to print the
// literal "undefined" in every document header ("UNDEFINED, MAIN"). Every value
// here falls back to '' so a missing variable leaves a blank, never "undefined".
export const COMPANY_NAME = process.env.REACT_APP_COMPANY_NAME || '';
export const COMPANY_CITY = process.env.REACT_APP_COMPANY_CITY || '';

/**
 * "Company, Place" header line. `place` is the warehouse name when the document
 * belongs to one; otherwise the company city. Empty parts are dropped, so with
 * nothing configured the header is simply the warehouse name.
 */
export const companyHeader = (place) =>
  [COMPANY_NAME, place || COMPANY_CITY].filter(Boolean).join(', ');
